module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_vm._v("Sobre o autor:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Antonio Pérez Hernández é professor do Ensino Fundamental (especialista em Educação Musical, Audição e Linguagem e Pedagogia Terapêutica), pedagogo, Mestre em Pesquisa e Inovação em Educação e Doutor, menção "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cum laude, ")]), _vm._v("pela sua Tese de Doutorado "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Avaliação da competência em comunicação linguística por meio de histórias no Ensino Fundamental")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ele foi premiado com um segundo prêmio no Prêmio de Criação Literária Nemira e um resultado finalista no Concurso Internacional de Romance de Fantasia e Terror de Dagón. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Publicou mais de quarenta livros, traduzidos em sete idiomas: grego, alemão, português, italiano, inglês, francês e holandês. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Atualmente combina seu trabalho docente com a escrita.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Local na rede Internet:"), _c('a', {
    attrs: {
      "href": "http://aphernandez.com",
      "target": "_blank"
    }
  }, [_vm._v("http://aphernandez.com")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Twitter:"), _c('a', {
    attrs: {
      "href": "https://twitter.com/ap_hernandez_",
      "target": "_blank"
    }
  }, [_vm._v("@ap_hernandez_")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Instagram:"), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/ap_hernandez_/",
      "target": "_blank"
    }
  }, [_vm._v("@ap_hernandez_")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0